var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { CodeInput } from '@myhealth-raccoon/components';
import { useController } from 'react-hook-form';
export function ControlledCodeInput(_a) {
    var control = _a.control, name = _a.name, rules = _a.rules, defaultValue = _a.defaultValue, disabled = _a.disabled, props = __rest(_a, ["control", "name", "rules", "defaultValue", "disabled"]);
    var _b = useController({ control: control, name: name, rules: rules, defaultValue: defaultValue, disabled: disabled }), 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _c = _b.field, _ = _c.ref, field = __rest(_c, ["ref"]), fieldState = _b.fieldState;
    return React.createElement(CodeInput, __assign({ fieldError: fieldState.isTouched ? fieldState.error : undefined, disabled: disabled }, props, field));
}
